import React from 'react';
import './WhatsApp.css';

// WhatsApp number: +91 9624797077 → international format without leading +
const WHATSAPP_NUMBER = '919624797077';
const WHATSAPP_MESSAGE = encodeURIComponent(
  'Hello, I am interested in your Ayurvedic herbal products. Could you please share more details?'
);

const WhatsApp: React.FC = () => {
  return (
    <a
      href={`https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_MESSAGE}`}
      className="whatsapp-float"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp"
      title="Chat on WhatsApp"
    >
      {/* WhatsApp SVG icon */}
      <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path
          d="M16 0C7.163 0 0 7.163 0 16c0 2.822.738 5.469 2.027 7.773L0 32l8.418-2.004A15.93 15.93 0 0 0 16 32c8.837 0 16-7.163 16-16S24.837 0 16 0zm0 29.333a13.27 13.27 0 0 1-6.771-1.854l-.485-.287-5.003 1.191 1.224-4.869-.316-.5A13.265 13.265 0 0 1 2.667 16C2.667 8.636 8.636 2.667 16 2.667S29.333 8.636 29.333 16 23.364 29.333 16 29.333zm7.27-9.961c-.398-.199-2.358-1.163-2.724-1.296-.366-.133-.632-.199-.898.199-.265.398-1.03 1.296-1.263 1.562-.232.265-.465.299-.863.1-.398-.199-1.68-.619-3.2-1.974-1.183-1.054-1.981-2.356-2.213-2.754-.232-.398-.024-.613.175-.812.179-.179.398-.465.597-.697.199-.232.265-.398.398-.664.133-.265.066-.498-.033-.697-.1-.199-.898-2.164-1.23-2.962-.324-.778-.652-.673-.898-.685l-.765-.013c-.265 0-.697.1-.1063.498-.365.398-1.396 1.363-1.396 3.328 0 1.965 1.43 3.863 1.629 4.129.199.265 2.814 4.298 6.82 6.029.953.411 1.696.657 2.276.841.956.304 1.826.261 2.514.158.767-.114 2.358-.963 2.691-1.893.333-.93.333-1.727.232-1.893-.099-.166-.365-.265-.763-.464z"
          fill="currentColor"
        />
      </svg>
    </a>
  );
};

export default WhatsApp;
